export default __webpack_public_path__ + "static/supply-logistics-479537a9bf2cdf267110595d0d79e1c7.webp";